import { connect } from 'react-redux';
import { getIsFetching } from '../../../redux/Reservation/selectors/ro-picklist';
import { getPaginationQueryOptions } from '../../../redux/Reservation/selectors/ro-picklist/pagination';
import { getROPicklistSearchQuery } from '../../../redux/Reservation/selectors/components/ro-picklist-search';
import { getOrderedOptions as getTrackingMethodOptions } from '../../../redux/Reservation/selectors/tracking-method-options';
import {
  onChangeQuery,
  onClearQuery
} from '../../../redux/Reservation/actions/components/ro-picklist-search';
import { ROPicklistOnClear } from '../../../redux/Reservation/actions/ro-picklist';
import {
  fetchROPicklists,
  fetchReservationTrackingMethodOptions
} from '../../../redux/Reservation/sagas/routines';
import ROPicklistSearch from '../../../components/reservations/ROPicklistSearch';

function mapStateToProps(state, props) {
  const searchQuery = getROPicklistSearchQuery(state);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };
  const trackingMethodOptions = getTrackingMethodOptions(state);
  return {
    ...props,
    searchQuery,
    queryOptions,
    trackingMethodOptions,
    isFetching: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchReservationTrackingMethodOptions());
    },
    onSubmit: queryOptions => {
      dispatch(ROPicklistOnClear());
      dispatch(fetchROPicklists(queryOptions));
    },
    onChange: query => {
      dispatch(onChangeQuery(query));
    },
    onClear: () => {
      dispatch(onClearQuery());
      dispatch(ROPicklistOnClear());
      dispatch(fetchROPicklists({}));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ROPicklistSearch);
